import { render, staticRenderFns } from "./NotBook.vue?vue&type=template&id=24c11ac8&scoped=true&"
import script from "./NotBook.vue?vue&type=script&lang=js&"
export * from "./NotBook.vue?vue&type=script&lang=js&"
import style0 from "./NotBook.vue?vue&type=style&index=0&id=24c11ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c11ac8",
  null
  
)

export default component.exports